import { withAuthGate } from '@sunrise-ui/composites';
import IntroRecordView from '@templates/IntroRecordView';
import { defaultBack } from '@utils/navigation';
import { router } from 'expo-router';
import React from 'react';

function ProfileIntroRecordScreen() {
  return (
    <IntroRecordView
      onRecordingFinished={(uri: string) => {
        router.replace(`/editProfile/preview?uri=${uri}`);
      }}
      handleBack={defaultBack('/editProfile/prep')}
    />
  );
}

export default withAuthGate(ProfileIntroRecordScreen);
